/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InfantOneYearOld,
    InfantOneYearOldFromJSON,
    InfantOneYearOldToJSON,
    InfantOneYearOldPagination,
    InfantOneYearOldPaginationFromJSON,
    InfantOneYearOldPaginationToJSON,
} from '../models';

export interface AdminInfantOneYearOldsIdGetRequest {
    id: number;
    userId?: number;
}

export interface InfantOneYearOldsGetRequest {
    babyId: number;
    page?: number;
    itemsPerPage?: number;
    orderType?: string;
    orderBy?: string;
}

export interface InfantOneYearOldsIdDeleteRequest {
    id: number;
}

export interface InfantOneYearOldsIdGetRequest {
    id: number;
}

export interface InfantOneYearOldsIdPutRequest {
    id: number;
    infantOneYearOld?: InfantOneYearOld;
}

export interface InfantOneYearOldsPostRequest {
    infantOneYearOld?: InfantOneYearOld;
}

export interface InfantOneYearOldsShareAllGetRequest {
    sourceUserId: number;
    babyId: number;
    page?: number;
    itemsPerPage?: number;
    orderType?: string;
    orderBy?: string;
}

export interface InfantOneYearOldsShareDetailGetRequest {
    recordId: number;
    sourceUserId: number;
}

/**
 * 
 */
export class InfantOneYearOldsApi extends runtime.BaseAPI {

    /**
     * 
     */
    adminInfantOneYearOldsIdGetRaw = async (requestParameters: AdminInfantOneYearOldsIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantOneYearOld>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling adminInfantOneYearOldsIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/infantOneYearOlds/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantOneYearOldFromJSON(jsonValue));
    }

    /**
     * 
     */
    adminInfantOneYearOldsIdGet = async (requestParameters: AdminInfantOneYearOldsIdGetRequest, initOverrides?: RequestInit): Promise<InfantOneYearOld> => {
        const response = await this.adminInfantOneYearOldsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    infantOneYearOldsGetRaw = async (requestParameters: InfantOneYearOldsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantOneYearOldPagination>> => {
        if (requestParameters.babyId === null || requestParameters.babyId === undefined) {
            throw new runtime.RequiredError('babyId','Required parameter requestParameters.babyId was null or undefined when calling infantOneYearOldsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.itemsPerPage !== undefined) {
            queryParameters['itemsPerPage'] = requestParameters.itemsPerPage;
        }

        if (requestParameters.orderType !== undefined) {
            queryParameters['orderType'] = requestParameters.orderType;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.babyId !== undefined) {
            queryParameters['babyId'] = requestParameters.babyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantOneYearOlds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantOneYearOldPaginationFromJSON(jsonValue));
    }

    /**
     * 
     */
    infantOneYearOldsGet = async (requestParameters: InfantOneYearOldsGetRequest, initOverrides?: RequestInit): Promise<InfantOneYearOldPagination> => {
        const response = await this.infantOneYearOldsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    infantOneYearOldsIdDeleteRaw = async (requestParameters: InfantOneYearOldsIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling infantOneYearOldsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantOneYearOlds/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    infantOneYearOldsIdDelete = async (requestParameters: InfantOneYearOldsIdDeleteRequest, initOverrides?: RequestInit): Promise<any> => {
        const response = await this.infantOneYearOldsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    infantOneYearOldsIdGetRaw = async (requestParameters: InfantOneYearOldsIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantOneYearOld>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling infantOneYearOldsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantOneYearOlds/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantOneYearOldFromJSON(jsonValue));
    }

    /**
     * 
     */
    infantOneYearOldsIdGet = async (requestParameters: InfantOneYearOldsIdGetRequest, initOverrides?: RequestInit): Promise<InfantOneYearOld> => {
        const response = await this.infantOneYearOldsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    infantOneYearOldsIdPutRaw = async (requestParameters: InfantOneYearOldsIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantOneYearOld>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling infantOneYearOldsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/infantOneYearOlds/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InfantOneYearOldToJSON(requestParameters.infantOneYearOld),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantOneYearOldFromJSON(jsonValue));
    }

    /**
     */
    infantOneYearOldsIdPut = async (requestParameters: InfantOneYearOldsIdPutRequest, initOverrides?: RequestInit): Promise<InfantOneYearOld> => {
        const response = await this.infantOneYearOldsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    infantOneYearOldsPostRaw = async (requestParameters: InfantOneYearOldsPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantOneYearOld>> => {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/infantOneYearOlds`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InfantOneYearOldToJSON(requestParameters.infantOneYearOld),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantOneYearOldFromJSON(jsonValue));
    }

    /**
     */
    infantOneYearOldsPost = async (requestParameters: InfantOneYearOldsPostRequest = {}, initOverrides?: RequestInit): Promise<InfantOneYearOld> => {
        const response = await this.infantOneYearOldsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    infantOneYearOldsShareAllGetRaw = async (requestParameters: InfantOneYearOldsShareAllGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantOneYearOldPagination>> => {
        if (requestParameters.sourceUserId === null || requestParameters.sourceUserId === undefined) {
            throw new runtime.RequiredError('sourceUserId','Required parameter requestParameters.sourceUserId was null or undefined when calling infantOneYearOldsShareAllGet.');
        }

        if (requestParameters.babyId === null || requestParameters.babyId === undefined) {
            throw new runtime.RequiredError('babyId','Required parameter requestParameters.babyId was null or undefined when calling infantOneYearOldsShareAllGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.itemsPerPage !== undefined) {
            queryParameters['itemsPerPage'] = requestParameters.itemsPerPage;
        }

        if (requestParameters.orderType !== undefined) {
            queryParameters['orderType'] = requestParameters.orderType;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.sourceUserId !== undefined) {
            queryParameters['sourceUserId'] = requestParameters.sourceUserId;
        }

        if (requestParameters.babyId !== undefined) {
            queryParameters['babyId'] = requestParameters.babyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantOneYearOlds/share/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantOneYearOldPaginationFromJSON(jsonValue));
    }

    /**
     * 
     */
    infantOneYearOldsShareAllGet = async (requestParameters: InfantOneYearOldsShareAllGetRequest, initOverrides?: RequestInit): Promise<InfantOneYearOldPagination> => {
        const response = await this.infantOneYearOldsShareAllGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    infantOneYearOldsShareDetailGetRaw = async (requestParameters: InfantOneYearOldsShareDetailGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantOneYearOld>> => {
        if (requestParameters.recordId === null || requestParameters.recordId === undefined) {
            throw new runtime.RequiredError('recordId','Required parameter requestParameters.recordId was null or undefined when calling infantOneYearOldsShareDetailGet.');
        }

        if (requestParameters.sourceUserId === null || requestParameters.sourceUserId === undefined) {
            throw new runtime.RequiredError('sourceUserId','Required parameter requestParameters.sourceUserId was null or undefined when calling infantOneYearOldsShareDetailGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.recordId !== undefined) {
            queryParameters['recordId'] = requestParameters.recordId;
        }

        if (requestParameters.sourceUserId !== undefined) {
            queryParameters['sourceUserId'] = requestParameters.sourceUserId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantOneYearOlds/share/detail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantOneYearOldFromJSON(jsonValue));
    }

    /**
     * 
     */
    infantOneYearOldsShareDetailGet = async (requestParameters: InfantOneYearOldsShareDetailGetRequest, initOverrides?: RequestInit): Promise<InfantOneYearOld> => {
        const response = await this.infantOneYearOldsShareDetailGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
